import React, { memo } from 'react';
import './index.less';
import classnames from 'classnames';
import ABSFieldTitle from '../Title';
import ABSFieldDesc from '../Desc';

export interface IABSFieldDescProps {
  className?: string;
  // title
  title?: string;
  required?: boolean;
  labelWidth?: string | number;
  removePaddingLeft?: boolean; // 是否移除左侧红点遗留间距
  removeMarginBottom?: boolean; // 是否移除组件底部14px的间距

  desc?: string;
  render?: () => React.ReactNode;

  contentAuto?: boolean;
}

const ABSFieldCustom: React.FC<IABSFieldDescProps> = props => {
  const { className, title, desc, required, removePaddingLeft, labelWidth, render, contentAuto = false } = props;

  const renderTitle = () => {
    if (title === undefined) {
      return;
    }
    const classs = classnames('custom-title', {
      'remove-padding-left': removePaddingLeft
    });
    const titleProps = { title, required, labelWidth };
    return <ABSFieldTitle {...titleProps} className={classs} />;
  };

  const clazz = classnames('custom', className);

  const contentClassName = contentAuto ?  'custom-content-auto' : 'custom-content-all';

  return (
    <div className={clazz}>
      {renderTitle()}
      <div className={contentClassName}>
        {render && render()}
        <ABSFieldDesc desc={desc} />
      </div>
    </div>
  );
};

export default memo(ABSFieldCustom);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSField/Custom/index.tsx